import { message } from "antd";
import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

axiosClient.interceptors.response.use(
  (response) => {
    if (![200, 201, 204].includes(response.status)) {
      throw new Error(response.data || "Lỗi không xác định");
    }
    return response.data || response;
  },
  (error) => {
    const statusCode = error.response?.data?.statusCode;

    if (statusCode === 401) {
      message.error("Phiên đã hết hạn hoặc yêu cầu không hợp lệ.");
    } else {
      message.error(error.response?.data?.message || "Đã xảy ra lỗi!");
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
